import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { SimpleImage, Typography } from "@parkschannel/ui";
export const MainBanner = ()=>{
    return /*#__PURE__*/ _jsxs("section", {
        className: "relative p-6 rounded-2xl overflow-hidden flex items-center min-h-[320px] md:min-h-[250px] md:p-8 lg:p-10",
        children: [
            /*#__PURE__*/ _jsx(SimpleImage, {
                src: "/media/man-with-backpack.webp",
                alt: "Beautiful view",
                fill: true,
                className: "object-cover object-right"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute top-0 left-0 w-full h-full bg-gradient-to-r from-black/50 to-black/0"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "relative lg:mt-6",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h1",
                        className: "text-white mb-3",
                        children: "Ready to plan your trip?"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "bodyXL",
                        className: "text-white md:max-w-[420px] lg:max-w-[562px]",
                        children: "Use our planning tool to make sure you have everything you need - and get great deals!"
                    })
                ]
            })
        ]
    });
};
